export default {
  lifeStudioMenu: 'Life Studio',
  lifeStudi: "OPPO Life Studi",
  lifeStudio: "Join the OPPO Life Studio to Craft Your Lifestyle",
  lifeStudioDesc: 'Welcome to the OPPO Life Studio, where OPPO fans come together to create custom merchandise that perfectly fits your lifestyle.',
  lifeStudioProduct: 'My Canvas Series',
  bannerSubTitle: "Craft Your Lifestyle",
  bannerDes: "Explore, experience, and create your own high-quality lifestyle with OPPO's collections.",
  merchandise: "Merchandise",
  merchandiseTitle: "Discover the Gems",
  merchandiseSubTitle: "Explore OPPO Life Studio's fresh finds designed to inspire a more vibrant, fashionable, and diverse you.",
  inspirationBoard: "Inspiration Board",
  inspirationSubTitle: "Share your inspiration and shape future OPPO Life Studio merchandise. If your entry is selected as inspiration, you'll have the chance to be among the first to get your hands on our fresh merch.",
  explore: 'Explore',
  inspirationRank: "Inspiration Rank",
  inspirationRankSubTitle: "Get yourself noticed! High ranking ideas have a higher chance of being selected, giving you the opportunity to join the OPPO Life Studio Experience Club.",
  userContens: 'User Content',
  story: 'Story',
  campaign: 'Campaigns',
  inspiration: 'Conversation',
  showCase: 'Showcase',
  allComment: 'All Inspirations',
  discussionAllComment:'All Comment',
  inspirationTitle: 'Bring Your Inspiration to Life',
  inspirationDescription: "Unleash your inspiration with the canvas bag series! Your ideas can be realized and further inspire peers to craft lifestyle.",
  home: 'Home',
  detail: 'Details',
  galleryTitle: "Canvas Bag Series",
  showcaseTitle: "Explore Diverse Lifestyles",
  showcaseSubtitle: "Get inspired and share your ideas with fans around the world!",
  learnMore: 'Learn More',
  upcoming:' Upcoming Collections',
  placeholderTips: 'New OPPO Life Studio collections are in the works. Keep an eye on the OPPO Community for latest additions.',
  commentTips:'Thank you, your comment has been submitted and is now visible in the Discussion section.',
  shareMine:'Share Mine'
}